<template>
  <div>
    <img v-if="this.$i18n.locale == 'ar'" class="imgs" src="../../assets/stopTaking/ar_con.png" alt=""/>
    <img v-if="this.$i18n.locale == 'en'" class="imgs" src="../../assets/stopTaking/en_con.png" alt=""/>
    <img v-if="this.$i18n.locale == 'es'" class="imgs" src="../../assets/stopTaking/esp_con.png" alt=""/>
    <img v-if="this.$i18n.locale == 'pt'" class="imgs" src="../../assets/stopTaking/prt_con.png" alt=""/>
    <img v-if="this.$i18n.locale == 'tr'" class="imgs" src="../../assets/stopTaking/tr_con.png" alt=""/>
    <img v-if="this.$i18n.locale == 'zh' || this.$i18n.locale == 'tc'" class="imgs" src="../../assets/stopTaking/zh_con.png" alt=""/>
  </div>
</template>
<script>
export default {
  name: "App",
  components: {},
  data() {
    return {
      userInfo: [],
    };
  },
  created() {
    this.$completes.complete("getUserInfo");
    window.getUserInfo = this.getUserInfo;
    window["getUserInfo"] = (data) => {
      this.getUserInfo(data);
    };
  },
  mounted() {},
  methods: {
    getUserInfo(data) {
      this.userInfo = JSON.parse(data);
      let langs = this.userInfo.lang.substring(0, 2);
      let lang = this.userInfo.lang;
      if (langs == "zh") {
        if (lang == "zh_TW" || lang == "zh_HK") {
          this.$i18n.locale = "tc";
        } else {
          this.$i18n.locale = "zh";
        }
      } else if (langs == "en") {
        this.$i18n.locale = "en";
      } else if (langs == "ar") {
        this.$i18n.locale = "ar";
      } else if (langs == "es") {
        this.$i18n.locale = "es";
      } else if (langs == "pt") {
        this.$i18n.locale = "pt";
      } else if (langs == "tr") {
        this.$i18n.locale = "tr";
      } else {
        this.$i18n.locale = "en";
      }
      document.querySelector("html").setAttribute("lang", this.$i18n.locale);
    },
  },
};
</script>
<style>
* {
  margin: 0;
  padding: 0;
}
</style>
